// 图片上传模块

//上传图片
function uploadImage(mein) {
  return new Promise(resolve => {
    let formData = new FormData();
    formData.append("action", "save");
    formData.append("userid", Cookies.get("userid-b"));
    formData.append("entid", mein.entid);
    formData.append("pagename", 'entimg');
    mein.blobName
      ? formData.append("entPicFile", mein.entPicFile, mein.blobName)
      : formData.append("entPicFile", mein.entPicFile);
    formData.append("entPicTitle", mein.entPicTitle);
    formData.append("entPicDes", mein.entPicDes);
    formData.append("picid", mein.picid);
    $.ajax({
      url: APIEntBin,
      async: true,
      type: "post",
      cache: false,
      processData: false,
      contentType: false,
      dataType: "json",
      data: formData,
      success: res => {
        if (res) {
          try {
            res ? resolve(res) : resolve(false);
          } catch (e) {
            console.log("上传图片出错");
            resolve(false);
          }
        } else {
          console.log("上传图片出错");
          resolve(false);
        }
      }
    });
  });
}

//上传头像
function uploadAvatar(entid, mein) {
  return new Promise(resolve => {
    let formData = new FormData();
    formData.append("action", "save");
    formData.append("pagename", "entimg");
    formData.append("userid", Cookies.get("userid-b"));
    formData.append("entid", entid);
    mein.blobName
      ? formData.append("entPicFile", mein.entPicFile, mein.blobName)
      : formData.append("entPicFile", mein.entPicFile);
    $.ajax({
      url: APIEntBin,
      async: true,
      type: "post",
      cache: false,
      processData: false,
      contentType: false,
      dataType: "json",
      data: formData,
      success: res => {
        if (res) {
          resolve(res);
        } else {
          console.log("上传头像出错");
          resolve(false);
        }
      }
    });
  });
}

//删除图片
function deletePic(entid, type, picid) {
  return new Promise(resolve => {
    let formData = new FormData();
    formData.append("action", "del");
    formData.append("userid", Cookies.get("userid-b"));
    formData.append("entid", entid);
    formData.append("pagename", type);
    formData.append("picid", picid);
    $.ajax({
      url: APIEntBin,
      async: true,
      type: "post",
      cache: false,
      processData: false,
      contentType: false,
      dataType: "json",
      data: formData,
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("删除图片出错");
            resolve(false);
          }
        } else {
          console.log("删除图片出错");
          resolve(false);
        }
      }
    });
  });
}

//获取企业图片
function getCompanyImages(entid) {
  return new Promise(resolve => {
    let formData = new FormData();
    formData.append("action", "edit");
    formData.append("userid", Cookies.get("userid-b"));
    formData.append("entid", entid);
    formData.append("pagename", "entpic");
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      cache: false,
      processData: false,
      contentType: false,
      dataType: "json",
      data: formData,
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取企业图片出错");
            resolve(false);
          }
        } else {
          console.log("获取企业图片出错");
          resolve(false);
        }
      }
    });
  });
}

//上传图片url
function upImgUrl(url, entid, pagename, mein) {
  return new Promise(resolve => {
    let formData = new FormData();
    formData.append("action", "save");
    formData.append("pagename", pagename);
    formData.append("userid", Cookies.get("userid-b"));
    formData.append("entid", entid);
    formData.append("imgurl", url);
    formData.append("entPicTitle", mein.entPicTitle);
    formData.append("entPicDes", mein.entPicDes);
    formData.append("picid", mein.picid);
    $.ajax({
      type: "post",
      url: APIB,
      data: formData,
      processData: false,
      contentType: false,
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("上传url失败");
            resolve(false);
          }
        } else {
          console.log("上传url失败");
          resolve(false);
        }
      }
    });
  });
}

//上传头像url
function upLogoUrl(url, entid, pagename) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "save", pagename: pagename, userid: Cookies.get("userid-b"), entid: entid, imgurl: url },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("上传url失败");
            resolve(false);
          }
        } else {
          console.log("上传url失败");
          resolve(false);
        }
      }
    });
  });
}

export default {
  uploadImage,
  uploadAvatar,
  deletePic,
  getCompanyImages,
  upImgUrl,
  upLogoUrl
};
